// import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from "react";
import Slider from "react-slick";
import "./Explore.css";

import img1 from "../../img/explore images/Albino Pheasant.jpg";
import img2 from "../../img/explore images/Alexandrine Parakeet.jpg";
import img3 from "../../img/explore images/Baboon.jpg";
import img4 from "../../img/explore images/Bengal Tiger.jpg";
import img5 from "../../img/explore images/Black Bear.jpg";
import img6 from "../../img/explore images/Black Buck.jpg";
import img7 from "../../img/explore images/Black Francolin.jpg";
import img8 from "../../img/explore images/Black Shoulder Peafowl.jpg";
import img9 from "../../img/explore images/Blue Bull.jpg";
import img10 from "../../img/explore images/Blue Peafowl.jpg";

import img11 from "../../img/explore images/Boar.jpg";
import img12 from "../../img/explore images/Brown Bear.jpg";
import img13 from "../../img/explore images/Budgerigar.jpg";
import img14 from "../../img/explore images/Cat.jpg";
import img15 from "../../img/explore images/Chinkara Deer.jpg";
import img16 from "../../img/explore images/Chukor.jpg";
import img17 from "../../img/explore images/Cockatiel.jpg";
import img18 from "../../img/explore images/Common Crane.jpg";
import img19 from "../../img/explore images/Common Ring Dove.jpg";
import img20 from "../../img/explore images/Crocodile.jpg";

import cross from "../../img/cross.png";


export default function Explore() {
  const [showImage, setShowImage] = useState(false)
  const [currentImg, setCurrentImg] = useState(img1)
  const [imageIndex, setImageIndex] = useState(0);
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20];

  var settings = {
    className: "center",
    centerMode: false,
    // dots: true,
    infinite: true,
    lazyLoad: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    beforeChange: (current, next) => setImageIndex(next),
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  const expandHandler = (img) => {
    setShowImage(true)
    setCurrentImg(img)
  };

   return (
    <div className="explore" id="library" >
    <h1>Explore</h1>
      <Slider {...settings}>
        {images.map((img, id) => (
          <div key={id} className={id-1 === imageIndex ? "slide activeSlide" : "slide"}>
            <img src={img} alt="img"
              onDoubleClick={() => expandHandler(img)}
            />
          </div>
        ))}
      </Slider>
      {
        showImage && (
          <div className="showImg">
            <img src={currentImg} alt="img" />
            <img src={cross} alt="*" className="cross" onClick={() => setShowImage(false)} />
          </div>
        )
      }
    </div>
  );
}
